import { createAction } from 'redux-actions';
import { actionKey } from './constants';
import { DeviationViewMode } from '@wix/da-react-context/pkg/SessionContext';
export var loadDeviation = createAction("".concat(actionKey, ".LOAD_DEVIATION"), function (deviation) { return ({ deviation: deviation }); });
export var initDeviationPage = createAction("".concat(actionKey, ".INIT_DEVIATION"), function (deviation, comments, safety) { return ({
    deviation: deviation,
    comments: comments,
    safety: safety,
}); });
export var enterZoomMode = createAction("".concat(actionKey, ".ZOOM_ENTER"), function (deviation) { return ({ deviation: deviation }); });
export var exitZoomMode = createAction("".concat(actionKey, ".ZOOM_EXIT"), function (deviation) { return ({ deviation: deviation }); });
export var fullscreenEntered = createAction("".concat(actionKey, ".VIEW.FULLSCREEN_ENTERED"), function (deviation) { return ({ deviation: deviation }); });
export var fullscreenExited = createAction("".concat(actionKey, ".VIEW.FULLSCREEN_EXITED"), function (deviation) { return ({ deviation: deviation }); });
export var togglePanel = createAction("".concat(actionKey, ".PANEL_TOGGLE"), function (panelType, actionBar) { return ({
    panelType: panelType,
    actionBar: actionBar,
}); });
export var showPanel = createAction("".concat(actionKey, ".PANEL_SHOW"), function (panelType, actionBar) { return ({
    panelType: panelType,
    actionBar: actionBar,
}); });
export var hidePanel = createAction("".concat(actionKey, ".PANEL_HIDE"), function (panelType) { return ({ panelType: panelType }); });
export var hidePanelPopup = createAction("".concat(actionKey, ".PANEL_POPUP.HIDE"), function () { return ({}); });
export var requestChangeViewMode = createAction("".concat(actionKey, ".VIEW.REQUEST_CHANGE_VIEW_MODE"), function (viewMode, deviation) { return ({
    viewMode: viewMode,
    deviation: deviation,
}); });
export var requestToggleTheaterView = function (deviation) {
    return requestChangeViewMode(DeviationViewMode.Theater, deviation);
};
export var requestToggleFullscreenView = function (deviation) {
    return requestChangeViewMode(DeviationViewMode.Fullscreen, deviation);
};
export var setScreenSize = createAction("".concat(actionKey, ".VIEW.SET_SCREEN_SIZE"), function (width, height) { return ({ width: width, height: height }); });
export var expandAndFocusCommentPanel = createAction("".concat(actionKey, ".EXPAND_AND_FOCUS_COMMENT_PANEL"), function (deviation, actionBarType) { return ({
    deviation: deviation,
    actionBarType: actionBarType,
}); });
//# sourceMappingURL=actions.js.map